<template>
  <Notification :show="notification.show" :type="notification.type" :message="notification.message" @click="this.notification.show = false" />
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 d-flex align-items-baseline justify-content-between"
            >
              <h6 class="text-white text-capitalize ps-3">User Apps</h6>
              <div class="col-3 pe-3 text-end">
                <material-button color="dark" variant="gradient" @click="toggleConfigurator">
                  <i class="fas fa-plus me-2"></i>
                  Add App
                </material-button>
              </div>            
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      App Name
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Token
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      How to use
                    </th>                    
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Status
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="app,index in userApps" v-bind:key="index">
                    <td>
                      <div class="d-flex px-2 py-1">

                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{app.appName}}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{app.createdAt}}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-baseline">
                        <p class="text-xs text-secondary mb-0 token">{{ app.token }}</p>...
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs copy-token"
                          data-toggle="tooltip"
                          data-original-title="Edit user"
                          @click.prevent="copyText(app.token)"
                        >Copy 
                        </a>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-baseline">
                        <p class="text-xs text-secondary mb-0 token" :ref="app._id">
                          curl --location 'https://api.infsite.org/br-websocket/track' --header 'token: {{app.token}}' --header 'Content-Type: application/json' --data '{"transactionId":"Your transactionId here","tracking":[{"phaseName":"Name you are tracking"}]}'
                        </p>...
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs copy-token"
                          data-toggle="tooltip"
                          data-original-title="Edit user"
                          @click.prevent="() => {

                            console.log(this.$refs[app._id][0].innerHTML)
                            copyText( this.$refs[app._id][0].innerHTML )
                          }"
                        >Copy 
                        </a>

                      </div>
                    </td>                    
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        ><MaterialSwitch /></span
                      >
                      
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs delete"
                        data-toggle="tooltip"
                        data-original-title="Edit user"
                        @click="deleteUserApp(app._id)"
                      >
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i>Delete
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Configurator
      :toggle="toggleConfigurator"
      :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']"
  >
    <CreateUserApp v-if="true" @retrive-event-child-component="getUserApp" />
  </Configurator>
</template>

<script>
import { httpPost } from '../services/axios'
import Notification from '../components/Notification.vue'
import MaterialButton from "../components/MaterialButton.vue"
import Configurator from '../components/Configurator.vue'
import { mapMutations, mapState } from "vuex"
import CreateUserApp from '../components/CreateUserApp.vue'
import MaterialSwitch from '../components/MaterialSwitch.vue'

export default {
  name: "tables",
  components: {
    Notification,
    MaterialButton,
    Configurator,
    CreateUserApp,
    MaterialSwitch
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    async getUserApp() {
      let res = await httpPost('getUserApp')
      this.userApps = res.data
    },
    async deleteUserApp(id) {
      let res = await httpPost('delete-userApp', {"_id": id})
      this.notification = { show: true, type: res.status == 200? 'success': 'danger', message: res.data }
      this.getUserApp()
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);

        this.notification = {
          show: true,
          type: 'warning',
          message: 'Token copied to clipboard!'
        }
        setTimeout(() => {
          this.notification.show = false
        }, 3000);
      } catch (err) {
        this.notification = {
          show: true,
          type: 'danger',
          message: 'Copy to clipboard unavailable!'
        }
      }
    }    
  },
  data() {
    return {
      userApps: [],
      notification: {
        show: false,
        type: null,
        message: null
      }
    }
  },
  computed: {
    ...mapState([
      "showConfig",
      "hideConfigButton",
    ])
  },
  watch: {
    notification: function () {
      if (this.notification.show) {
        setTimeout(() => this.notification.show = false, 3000)
      }
    }
  },  
  mounted() {
    this.getUserApp()
  }
};
</script>
<style scoped>
.token {
  max-width: 15em;
  overflow: overlay;
  font-size: 10px !important;
}
.delete {
  padding: .3em;
}
.delete:hover {
  background-color: #e91e63;
  color: #FFF !important;
  border-radius: 5px;
}
.copy-token {
  padding: .3em;
}
.copy-token:hover {
  background-color: #66bb6a;
  color: #FFF !important;
  border-radius: 5px;
}
</style>